const KNOWN = ['draft', 'planned', 'ready', 'working', 'input_needed', 'completed', 'failed'];

/**
 * statusDotStatus — normalize a cell status into one of the known statuses the shared flow-kit tag dot
 * knows how to color (see flowkit.css's `.bh-status-*` rules). Unknown or missing statuses fall back to
 * `draft` so the tag never renders without a color.
 */
export function statusDotStatus(status) {
  return KNOWN.includes(status) ? status : 'draft';
}
